import React from 'react'
import { Box } from '@mui/material'

import type { IBlockPayloadVideo } from '../../../types'
import { getYouTubeVideoId } from '../../BlockEditor/utils'

export const VideoRenderer: React.FC<{ payload: IBlockPayloadVideo }> = ({ payload }) => {
  const videoId = getYouTubeVideoId(payload.url ?? '')
  if (!videoId) return null
  const embedUrl = `https://www.youtube.com/embed/${videoId}`

  return (
    <Box
      sx={{
        position: 'relative',
        width: payload.fullWidth ? '100%' : (payload.width ? `${payload.width}px` : 560),
        maxWidth: '100%',
        aspectRatio: '16/9',
        mx: 'auto',
        borderRadius: 1,
        overflow: 'hidden',
        bgcolor: '#000',
      }}
    >
      <iframe
        src={embedUrl}
        title="YouTube video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
      />
    </Box>
  )
}
